import styled from 'styled-components';
import Colours from '../State/Colours';
import Button from './Button';

// export default styled(Button)`
//     border: 1px solid ${Colours.gray50};
//     color: ${Colours.gray};

//     &:hover {
//         border: 1px solid ${Colours.gray};
//         background-color: ${Colours.gray10};
//     }

//     &:active {
//         border: 1px solid ${Colours.secondary};
//     }
// `;

export default styled(Button)`
    border: 1px solid ${Colours.primary50};
    color: ${Colours.primary};

    &:hover {
        border: 1px solid ${Colours.primary};
        background-color: ${Colours.primary10};
    }

    &:active {
        border: 1px solid ${Colours.secondary};
    }
`;


// WEBPACK FOOTER //
// ./src/Components/ButtonGray.tsx